/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';
import {Row} from 'react-bootstrap';
import {useGenericModelHooks, useShouldEditField} from "../../../Hooks/GenericModelHooks";
import {StandardModelViewerRecordRenderer} from "../RecordRenderers/StandardModelViewerRecordRenderer";
import * as renderers from "../RecordRenderers";


export const ProjectContactRelationshipsModelViewerRenderer = function (props) {
    const {
        getFieldDefs,
        updateField,
        updateFields,
        sortFieldDefs,
    } = useGenericModelHooks(props);

    const shouldEditField = useShouldEditField();
    const editMode = shouldEditField(props);

    const {
        FieldDef,
        FieldDefinitionGroups,
        SkipBorder,
        Validation,
        RootData,
        Data,
        OnValidationUpdate,
        CustomData,
        IsNewModel,
        DefaultSelectedFieldDefKey,
        tdClassName = '',
        defaultValue = undefined,
        subText = null,
        FieldGroup
    } = props;
    
    return <Row className="sb-model-viewer sb-project-contact-relationship-model-editor-root">
        {
            sortFieldDefs(FieldGroup?.value).map(fieldDef => {
                const FieldDefRenderer = renderers?.[fieldDef?.renderer ?? 'StandardModelViewerRecordRenderer'];

                if(typeof FieldDefRenderer !== 'function') {
                    console.log('invalid fieldDefRenderer', FieldDefRenderer);
                    return <b>{fieldDef?.renderer}</b>;
                }
                
                return <FieldDefRenderer
                    key={fieldDef?.key}
                    EditMode={editMode}
                    FieldDefinitionGroups={FieldDefinitionGroups}
                    FieldDef={fieldDef}
                    RootData={RootData}
                    Data={Data}
                    Validation={Validation?.[fieldDef?.key]}
                    UpdateField={updateField}
                    UpdateFields={updateFields}
                    GetFieldDefs={getFieldDefs}
                    OnValidationUpdate={OnValidationUpdate}
                    SkipBorder={SkipBorder}
                    CustomData={CustomData}
                    IsNewModel={IsNewModel}
                    DefaultSelectedFieldDefKey={DefaultSelectedFieldDefKey}
                />;
            })
        }
    </Row>;
};
